
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="modalModificacion"
            scrollable
            title="Nueva modificación a expediente tecnico"
            title-class="font-18"
            size="lg"
            @ok="guardarNuevaModificacion"
            centered
        >
          <b-overlay :show="isLoadingModal" rounded="sm">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>Expediente</label>
                <v-select
                    :options="expedientes"
                    label="obra_expediente"
                    :reduce="desc=>desc.expediente_id"
                    v-model="model_modificacion.expediente_id"
                    v-show="nuevo_modelo"
                />
                <p  v-show="!nuevo_modelo">{{model_modificacion.expediente}}</p>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>Descripción</label>
                <input class="form-control" v-model="model_modificacion.descripcion">
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>Abreviatura</label>
                <input class="form-control" v-model="model_modificacion.abreviatura" maxlength="9">
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>Fecha de aprobación</label>
                <VueCtkDateTimePicker
                    v-model="model_modificacion.fecha_aprobacion"
                    :locale="'es'"
                    :input-size="'sm'"
                    :format="'YYYY-MM-DD'"
                    :formatted="'YYYY-MM-DD'"
                    :range="false"
                    :auto-close="true"
                    :only-date="true"
                    :no-header="true"
                />
                <!--:no-header="true"-->
              </div>
            </div>

          </b-overlay>
        </b-modal>
        <div class="form-row">
          <div class="form-group col-md-3">
            <button  type="button"   class="btn btn-primary mt-4" v-on:click="nuevo">Nuevo</button>
          </div>

        </div>
        <vue-good-table
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-search="onSearch"
          :totalRows="totalRecords"
          :isLoading.sync="isLoading"
          :pagination-options="{
              enabled: true,
              }"
          :rows="rows"
          :columns="columns"
          :globalSearch="true"
          @on-row-dblclick="onRowDoubleClick"
          styleClass="vgt-table striped smalltable"
          :search-options="{
              enabled: true,
              //trigger: 'enter',
              skipDiacritics: true,
              placeholder: 'buscarEnTabla',
            }"
        >
            <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'acciones'">
                <router-link :to="{path:'/expediente/modificaciones/ver/'+props.row.id}" v-if="$can('expedientes-modificaciones-ver')">
                    <button class="btn btn-success btn-icon btn-sm mr-1"><i class="fa fa-eye"></i></button>
                </router-link>
                <button class="btn btn-primary btn-icon btn-sm mr-1"
                        v-if="$can('expedientes-modificaciones-modificar')"
                        v-on:click="modificar(props.row.id)"
                >
                  <i class="fa fa-edit"></i>
                </button>

                <router-link :to="{path:'/expediente/modificaciones/'+props.row.id}"  v-if="$can('expedientes-modificaciones-modificar')">
                    <button class="btn btn-primary btn-icon btn-sm mr-1"><i class="fa fa-list"></i></button>
                </router-link>
                <button v-if="$can('expedientes-modificaciones-eliminar')" class="btn btn-danger btn-icon btn-sm ml-1" v-on:click="borrar(props.row.id)" ><i class="fa fa-trash"></i></button>
                <!--<span style="font-weight: bold; color: blue;">{{props.row.age}}</span>-->
            </span>
                <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
            </template>
        </vue-good-table>
    </Layout>
</template>
<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import PageHeader from "@/components/page-header";


    /**
     * Dashboard Component
     */
    export default {
        page: {
            title: "Usuarios lista",
            meta: [{ name: "description", content: appConfig.description }],
        },
        components: {

            Layout,
            PageHeader,
        },
        data() {
            return {
                title: "Modificación de expediente tecnico",
                items: [
                    {
                        text: "Administración",
                        href: "/",
                    },
                    {
                        text: "Usuarios",
                        active: true,
                    },
                ],
                model_modificacion:{
                  descripcion:"",
                  expediente_id:null,
                  abreviatura:"",

                },

                isLoading: false,
                columns: [
                    {
                        label: 'id',
                        field: 'id',
                    },
                    {
                      label:'E.T.',
                      field:'expediente'
                    },
                    {
                      label: 'Descripción',
                      field: 'descripcion',
                    },
                    {
                        label: 'Fecha de aprobación',
                        field: 'fecha_aprobacion',
                    },
                    {
                        label: 'Acciones',
                        field: 'acciones',
                        width:'20%'
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {
                    },
                    sort: {
                        field: '',
                        type: '',
                    },
                    page: 1,
                    perPage: 10
                },
                expedientes:[],
                expediente_id:null,
                isLoadingModal:false,
                nuevo_modelo:false

            };
        },

        methods: {
          guardarNuevaModificacion(event){
            event.preventDefault();
            if(this.model_modificacion.descripcion.trim()==""){
              this.$swal('Cuidado','Ingrese una descripcion','warning')
              return;
            }
            if(this.model_modificacion.expediente_id==null){
              this.$swal('Cuidado','Seleccione un expediente','warning')
              return;
            }

              this.isLoadingModal=true;
              const requestData = {
                descripcion: this.model_modificacion.descripcion,
                expediente_id: this.model_modificacion.expediente_id,
                abreviatura: this.model_modificacion.abreviatura,
                fecha_aprobacion: this.model_modificacion.fecha_aprobacion
              };

              const requestUrl = this.nuevo_modelo ?
                  process.env.VUE_APP_BACKEND + '/api/expedientes/modificaciones' :
                  process.env.VUE_APP_BACKEND + '/api/expedientes/modificaciones/' + this.model_modificacion.id;

              const requestMethod = this.nuevo_modelo ? 'post' : 'put';

              this.axios[requestMethod](requestUrl, requestData)
                  .then(() => {
                    this.$bvModal.hide("modalModificacion");
                    this.loadItems();
                  })
                  .catch(() => {
                    this.$swal('error', 'Error agregando', 'error');
                  })
                  .finally(() => {
                    this.isLoadingModal = false;
                    this.loadItems();
                  });

          },
          nuevo(){
            this.nuevo_modelo=true;
            this.model_modificacion={
                  descripcion:"",
                  expediente_id:null,
                  abreviatura:"",
            };
            this.$bvModal.show("modalModificacion");
          },
          modificar(id){
            this.isLoading=true;
            this.nuevo_modelo=false;
            this.axios.get(process.env.VUE_APP_BACKEND + '/api/expedientes/modificaciones/'+id)
                .then((response)=>{
                  this.model_modificacion=response.data;
                  this.$bvModal.show("modalModificacion");
                })
                .catch(()=>{
                  this.$swal('error','error','error')
                })
                .finally(()=>{
                  this.isLoading=false;
                })
          },
          decimal(value)
          {
              if (value===null){
                  return '-'
              }
              else
              {
                  return parseFloat(value).toFixed(2)
              }
          },
          borrar(id){
              this.$swal.fire({
                  title: '¿Esta seguro?',
                  text: "No se puede revertir esta accion!",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Si, borralo!'
              }).then((result) => {
                  if (result.value) {
                      this.isLoading=true;
                      this.axios.delete(process.env.VUE_APP_BACKEND +'/api/expedientes/modificaciones/'+id)
                          .catch(()=>{
                              this.$swal('error','Existen registros internos','error');
                          })
                          .finally(
                              ()=>
                              {
                                  this.isLoading=false;
                                  this.loadItems();
                              }

                          );
                  }
              })
          },
            onSearch :function(params)
            {
                this.updateParams({page: params.page});
                this.updateParams({searchTerm: params.searchTerm});
                this.loadItems();
            },
            say: function (message) {
                alert(message)
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.columns[params.columnIndex].field,
                    }],
                });
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            // load items is what brings back the rows from server
            loadItems() {
                this.isLoading=true;
                this.axios.get( process.env.VUE_APP_BACKEND+'/api/expedientes/modificaciones/tabla',
                    {
                      'params':this.serverParams
                    })
                    .then( (response) =>{
                        this.totalRecords = response.data.total_records;
                        this.rows = response.data.data;
                        this.isLoading=false;
                    })
                    .catch(() =>{
                        this.isLoading=false;
                        //console.log(error);
                    });
            },
            onRowDoubleClick(params){
                this.$router.push('administracion/usuarios/'+params.row.id);
            },

        },
        mounted() {
          this.loadItems();
          this.$cargarExpedientes( (res)=>{
            this.expedientes=res.data
          },()=>{});




        }
    };
</script>

<style>
    .smalltable{
        font-size: 12px !important;
    }

</style>
